module.exports = __webpack_public_path__ + "static/assets/459442220b48c88dcd54b50d1a785743.png";